import { FormRegistry } from './index';
import { carePlanBehavior } from './CarePlanBehavior';
import { defaultBehavior } from './DefaultBehavior';
import { initialAssessmentBehavior } from './InitialAssessmentBehavior';
import { programCompletionBehavior } from './ProgramCompletionBehavior';

// Register all form behaviors
FormRegistry.register('Care Plan', carePlanBehavior);
FormRegistry.register('Initial Assessment', initialAssessmentBehavior);
FormRegistry.register('Program Completion', programCompletionBehavior);

// Set default behavior for all other form types
export const getFormBehavior = (formType: string) => {
  const normalizedFormType = `${formType || ''}`.trim();
  return FormRegistry.get(formType) || FormRegistry.get(normalizedFormType) || defaultBehavior;
};

export { FormRegistry };
